import { useNavigate } from "react-router-dom";
import styles from "./NavLogBut.module.css";

interface Props {
    displayText?: string;
    target?: string;
}


const NavLogBut = ({ displayText, target }: Props) => {

    return (
        <button
            className={styles.loginBtn}
            onClick={() => {
                console.log("navigating to login");
                window.location.href = target || "/"
            }}
        >
            {displayText || ""}
        </button>
    );
};

export default NavLogBut;
